export const totalProductsSold = {
	label: "Total de productos vendidos",
};
